import React from 'react';
import { Target } from 'lucide-react';

interface SportsIQsLogoProps {
  className?: string;
  iconSize?: string;
}

export const SportsIQsLogo = ({ className = "", iconSize = "h-5 w-5" }: SportsIQsLogoProps) => {
  return (
    <div className={`flex items-center ${className}`}>
      <Target className={iconSize} />
    </div>
  );
};